/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagsRemediation {
    getFixupPrototypeFunction() { return TagsRemediation.fixupPrototype; }

    static newInstance(model: Partial<TagsRemediation>): TagsRemediation {
        let obj = Object.assign(new TagsRemediation(), model);
        TagsRemediation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagsRemediation>): TagsRemediation {
        if (!model) return null;
        return TagsRemediation.newInstance(<TagsRemediation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagsRemediation) {
        if (!obj) return;

        models.TagsRemediation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagsRemediation): boolean {
        Object.setPrototypeOf(obj, TagsRemediation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * resource_category (it can be fetched from the tag posture resource based on input filters api
     */
    resource_category: string;

    /**
     * resource_type (it can be fetched from the tag posture resource based on input filters api)
     */
    resource_type: string;

    /**
     * resource (it can be fetched from the tag posture resource based on input filters api)
     */
    resource: string;

    /**
     * resource_filter will be region, resource group or zone name. It can be fetched from the list resource visibility count api
     */
    resource_filter: string;

    /**
     * resource_id (it can be fetched from the tag posture resource based on input filters api)
     */
    resource_id: string;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
